module.exports = __webpack_public_path__ + "img/talent-turbo-logo1.159b1304.png";